import React, { useState } from 'react'
import Drawer from 'components/shared/Drawer';
import strings from 'strings'
import { Tabs, Tab } from 'components/shared/Tabs'
import SosSearch from 'components/QuickSearch/SOS/SosSearch';
import AllStatesSearch from 'components/QuickSearch/SOS/AllStatesSearch';
import AuthService from "../../../../../../../../../tools/AuthService";

const sosStrings = strings.APPLICANT.SOS

const sosSearchDrawerTabs = [
    { label: 'SOS Search' },
    { label: 'All States Search' }
]

const SosSearchDrawer = (props) => {

    const { open, onClose, requestDecision, applicantId, creditCosts, updateSummaryCard } = props
    const [activeTab, setActiveTab] = useState(0);
    const sosAllStatesSearchEnabled = AuthService.getClientFeatures().sosAllStatesSearchEnabled;

    const filteredTabs = sosAllStatesSearchEnabled
        ? sosSearchDrawerTabs
        : [sosSearchDrawerTabs[0]];

    const handleTabChange = (event, newValue) => {
        setActiveTab(newValue);
    };

    return (
        <Drawer
            open={open}
            title={sosStrings.SOS_SEARCH}
            onClose={onClose}
            maxWidth="lg"
        >
            <div className='p-3'>
                <Tabs
                    data={filteredTabs}
                    value={activeTab}
                    onChange={handleTabChange}
                />
                <Tab value={activeTab} index={0}>
                    <SosSearch 
                        applicantId={applicantId} 
                        requestDecision={requestDecision}
                        updateSummaryCard={updateSummaryCard}
                        closeDrawer={onClose} 
                        creditCosts={creditCosts}
                    />
                </Tab>
                <Tab value={activeTab} index={1}>
                    <AllStatesSearch
                        applicantId={applicantId}
                        updateSummaryCard={updateSummaryCard}
                        closeDrawer={onClose}
                        creditCosts={creditCosts}
                    />
                </Tab>
            </div>
        </Drawer>
    )
}

export default SosSearchDrawer